// removed by extract-text-webpack-plugin
module.exports = {"publicspan":"wmf-1M67unU2","page":"wmf-2uuxgeY6"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/brandqualification/brand-qualification-list.module.less
// module id = 3849
// module chunks = 0